import React from 'react';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import * as S from './HowToWinCard.styles';

/**
 * "How to win" summary card for how-to-play pages.
 * Gradient (teal) by default; `tone="light"` renders a white card for nested use
 * inside mode cards.
 *
 * Props:
 *  - title: string
 *  - success?: string (win outcome line)
 *  - fail?: string (lose outcome line)
 *  - closing?: string (italic closing line)
 *  - tone?: 'gradient' | 'light'
 */
const HowToWinCard = ({ title, success, fail, closing, tone = 'gradient' }) => {
  return (
    <S.Card $tone={tone}>
      {title && <S.Title>{title}</S.Title>}
      {success && (
        <S.Outcome $win>
          <FaCheckCircle />
          <span>{success}</span>
        </S.Outcome>
      )}
      {fail && (
        <S.Outcome>
          <FaTimesCircle />
          <span>{fail}</span>
        </S.Outcome>
      )}
      {closing && <S.Closing>{closing}</S.Closing>}
    </S.Card>
  );
};

export default HowToWinCard;
